angular.module("app").directive("colorComparisonForLegal", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbColorComparisonForLegal/dbColorComparisonForLegalView.html",
    link: link,
    scope: {
      selectedData: "=",
      allData: "="
    }
  };
});
